import { Grid } from "@mui/material";
import MxDetailSubTitle from "@rf-l1/page/details/MxDetailSubTitle";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";
import MxButtonLocation from "@rf-l1/buttons/MxButtonLocation";
import MxMapViewer from "@rf-l1/map-v2/components/MxMapViewer";
import MxDetailLabelValue from "@rf-l1/page/details/MxDetailLabelValue";

const MainDetailLocation = () => {
  const { city, sector, address, latitude, longitude } = usePropertyDetailPage();
  return (
    <Grid container gap={3}>
      <Grid item xs={12}>
        <MxDetailSubTitle label="Ubicación" />
      </Grid>
      <Grid container item xs={12} spacing={2} rowSpacing={0.5} alignItems="center">
        {city && (
          <Grid item xs={6} md={"auto"}>
            <MxDetailLabelValue label="Ciudad: " value={city} />
          </Grid>
        )}
        {sector && (
          <Grid item xs={6} md={"auto"}>
            <MxDetailLabelValue label="Sector: " value={sector} />
          </Grid>
        )}
        {address && (
          <Grid item xs={6} md={"auto"}>
            <MxDetailLabelValue label="Dirección: " value={address} />
          </Grid>
        )}

        {latitude && longitude && (
          <Grid
            item
            xs={6}
            md={"auto"}
            display={"flex"}
            justifyContent={{
              xs: "center",
              md: "none"
            }}
          >
            <MxButtonLocation
              latitude={latitude ?? 0}
              longitude={longitude ?? 0}
              children="Ver en mapa"
            />
          </Grid>
        )}
      </Grid>

      <Grid item xs={12}>
        <MxMapViewer
          lat={latitude ?? 0}
          lng={longitude ?? 0}
          zoom={9}
          disabled={true}
        />
      </Grid>
    </Grid>
  );
};

export default MainDetailLocation;
